import React from 'react';
import { LegalList, LegalNotice, LegalP, LegalPage, LegalSection } from '../components/Legal/LegalPage';

const CommunityPolicy: React.FC = () => {
  const updated = 'May 14, 2026';

  return (
    <LegalPage
      title="Community & Lead Posting Policy"
      updated={updated}
      intro="RideSaathi depends on accurate, ride-related submissions from authorized sources and verified contributors."
    >
      <LegalNotice>
        RideSaathi may remove, mask, expire, reject, or restrict any listing that appears incorrect, expired, unauthorized, misleading, unsafe, unlawful, or unrelated to ride requirements.
      </LegalNotice>

      <LegalSection title="1. Purpose">
        <LegalP>
          This policy applies to ride lead submissions, contributor activity, public or permitted ride requirements, connected ride information channels, user reports, support requests, and platform-generated lead organization.
        </LegalP>
        <LegalP>
          The goal is to keep RideSaathi useful for drivers while respecting privacy, safety, and lawful transport activity.
        </LegalP>
      </LegalSection>

      <LegalSection title="2. Acceptable ride lead information">
        <LegalList
          items={[
            'Genuine ride requirements with route, date, time, vehicle preference, fare expectation, and relevant contact details where permitted.',
            'Ride lead submissions from authorized sources, verified contributors, connected ride information channels, and public or permitted ride requirements.',
            'Updates that correct route, timing, fare, contact, availability, or expiry information.',
          ]}
        />
      </LegalSection>

      <LegalSection title="3. Community rules">
        <LegalList
          items={[
            'No fake ride posts.',
            'No spam, repeated irrelevant listings, or promotional flooding.',
            'No abusive, threatening, obscene, discriminatory, or hateful content.',
            'No sharing misleading, false, or unauthorized contact details.',
            'No harassment of drivers, riders, contributors, staff, or other users.',
            'No illegal transport activity, unlawful services, permit violations, unsafe conduct, or evasion of applicable rules.',
          ]}
        />
      </LegalSection>

      <LegalSection title="4. Contact details and masking">
        <LegalP>
          Contact details may be masked publicly and may only be visible to verified or logged-in users where applicable. Users who unlock or view contact details must use them only for the relevant ride requirement.
        </LegalP>
        <LegalP>
          Do not publish, resell, misuse, spam, or redistribute contact details obtained through RideSaathi.
        </LegalP>
      </LegalSection>

      <LegalSection title="5. Reporting and removal">
        <LegalP>
          Users can report incorrect, expired, unauthorized, misleading, duplicate, abusive, or non-ride listings through support, in-app reporting tools, or the Data Deletion / Opt-out page.
        </LegalP>
        <LegalP>
          RideSaathi may review the report, ask for additional details, mask contact information, expire the listing, remove the listing, restrict accounts, or reject the report when there is not enough information.
        </LegalP>
      </LegalSection>

      <LegalSection title="6. Contributor responsibilities">
        <LegalList
          items={[
            'Submit only information you are authorized to share.',
            'Keep ride details accurate and update or report listings when they expire.',
            'Avoid including personal information that is not needed for the ride requirement.',
            'Respect requests for correction, removal, deletion, or opt-out.',
          ]}
        />
      </LegalSection>

      <LegalSection title="7. Platform disclaimer">
        <LegalP>
          RideSaathi organizes rides but does not guarantee ride booking, payment, safety, driver or customer verification, or completion of any ride. Drivers and users must independently verify ride details, identity, permits, fare, and safety before proceeding.
        </LegalP>
      </LegalSection>

      <LegalSection title="8. Third-party platform disclaimer">
        <LegalP>
          RideSaathi does not claim partnership, sponsorship, endorsement, or affiliation with WhatsApp, Meta, Google, Apple, or any third-party platform unless officially stated in writing by RideSaathi and the relevant third party.
        </LegalP>
      </LegalSection>
    </LegalPage>
  );
};

export default CommunityPolicy;
